export default __webpack_public_path__ + "static/media/cash-and-equivalents.37dae43c.svg";